/**
 * client/src/lib/text-format.ts
 *
 * Shared plain-text formatting helpers. `titleCase` was previously copy-pasted
 * across org-members.tsx, former-members-section.tsx, and both team-members
 * pending-row components (Reuse-First, DEVELOPMENT/code-style.md) — one copy
 * here, all callers import it.
 */

/** Upper-cases the first character only; leaves the rest of the string untouched. */
export function titleCase(value: string): string {
  return value.length === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1);
}

/**
 * Pick the correct WHOLE phrase for a count, substituting `{n}` for the number.
 *
 * Takes two complete forms rather than splicing an "s" onto a noun, and that is
 * the entire point. The spliced idiom — `${n} item${n === 1 ? "" : "s"}` —
 * appears ~36 times in this codebase and is correct only while the sentence
 * carries no verb and no pronoun. The moment it does, the noun agrees and
 * nothing else does: "1 item are on their way", "1 failed send remain
 * available". Three such strings shipped on the bulk-send panel alone, one of
 * them on a money confirmation screen.
 *
 * Passing both forms makes that failure unrepresentable — there is no way to
 * pluralise half a sentence.
 *
 *   countPhrase(1, "{n} item is on its way", "{n} items are on their way")
 */
export function countPhrase(count: number, one: string, many: string): string {
  return (count === 1 ? one : many).replaceAll("{n}", String(count));
}
